import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';
import '../styles/Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-section">
                    <h4>Duckerr</h4>
                    <Link to="/">Home</Link>
                    <Link to="/view-ducks">Duck Pond</Link>
                    <Link to="/leaderboards">Leaderboards</Link>
                </div>
                <div className="footer-section">
                    <h4>Get the App</h4>
                    <span className="footer-platform-available">Available on Web</span>
                    <span className="footer-platform-coming">iOS App — Coming Soon</span>
                    <span className="footer-platform-coming">Android App — Coming Soon</span>
                </div>
                <div className="footer-section">
                    <h4>Legal</h4>
                    <Link to="/privacy">Privacy Policy</Link>
                    <Link to="/terms">Terms of Service</Link>
                </div>
            </div>
            <div className="footer-bottom">
                &copy; {new Date().getFullYear()} Duckerr. All rights reserved. Not affiliated with Jeep&reg;.
            </div>
        </footer>
    );
}

export default Footer;
